module.exports = __webpack_public_path__ + "img/党的章程.73be3153.png";